import React from 'react'
import PageBreadcrumbs from 'organization/Event/Page/PageBreadcrumbs'
import styled from 'styled-components'
import Button from 'lib/ui/Button'
import {DndContext} from '@dnd-kit/core'
import {useUpdateTemplate} from 'organization/Event/Certificates/CertificateEditor'
import Blocks from 'organization/Event/Certificates/CertificateEditor/Blocks'
import {Certificate} from 'lib/event-api/certificates/types'
import {createTextBlock} from 'lib/event-api/certificates/create-text-block'

interface ContentProps {
  certificate: Certificate
  template: NonNullable<Certificate['template']>
}

export default function Content(props: ContentProps) {
  const {template, certificate} = props

  const updateTemplate = useUpdateTemplate()

  const addText = () => {
    const newBlock = createTextBlock()

    updateTemplate({
      blocks: {
        [newBlock.id]: newBlock,
      },
    })
  }

  return (
    <PageBreadcrumbs page="Certificates">
      <Page>
        <Header>
          <StyledButton
            size="small"
            variant="contained"
            color="primary"
            fullWidth
            onClick={addText}
          >
            Add Text
          </StyledButton>
        </Header>
        <DndContext>
          <Blocks template={template} certificate={certificate} />
        </DndContext>
      </Page>
    </PageBreadcrumbs>
  )
}

const Page = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 72px;
  box-shadow: 20px 20px 50px #ddd;
  margin-bottom: 1px;
`

const StyledButton = styled(Button)`
  border: 10px solid #ffffff;
  border-radius: 15px;
  max-width: 300px;
  &:hover {
    opacity: 0.9;
  }
`
